<template>
  <div>
    <el-input
    :placeholder="column.placeholder"
    :disabled="column.disabled"
    v-model="value"
    @input="handleChange" />
  </div>
</template>
<script>
export default {
  name: 'AvueLicensePlate',
  inject: ['viewFormData'],
  props: ['column', 'value'],
  mounted() {
  },
  computed: {

  },
  methods: {
    handleChange(val) {
      this.$emit('input', val)
    }
  },
  created() {

  }
}
</script>
 <style lang="scss">
  .iframe {
    width: 100%;
    border: 0;
    overflow: hidden;
    box-sizing: border-box;
  }
</style>
